import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';


import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';



const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));

function RemplacementANeufDialogContent({ onChange, action }) {

    const classes = useStyles();

    const [numeroPiece, setNumeroPiece] = useState('');

    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (numeroPiece === '') {
                return {
                    actionData: null, clotureData: null
                };
            }


            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.NumeroPiece,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Pièce de remplacement",
                        position: 0,
                        valeurString: numeroPiece
                    }]
            };


            let clotureData = {
                motifResolutionCode: MotifResolutionCodes.RenvoiMarchandiseFacture,
                causePrincipaleCode: CausePrincipaleCodes.Sav,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };


            return { actionData, clotureData };
        }


        const { actionData, clotureData } = getActionData();

        onChange(actionData, clotureData);
    }, [action.code, onChange, numeroPiece]);

    return (
        <DialogContent>

            <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
            <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Clôturer ce dossier après-vente`}</Typography>

            <TextField
                className={classes.formControl}
                value={numeroPiece}
                onChange={e => setNumeroPiece(e.target.value)}
                variant={"filled"}
                label={"Pièce de remplacement"}
            />

        </DialogContent>
    );

}


export default RemplacementANeufDialogContent;